import "./FormSuccess.css";
import React from "react";
import { Link } from "react-router-dom";

import paymentSuccess from "../../../assets/images/pay/happyWoman.png";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CircleIcon from "@mui/icons-material/Circle";

const FormSuccess = ({ text1, text2 }) => {
  return (
    <>
      <div className="form_success_pages rtl">
        <div className="form_success_div">
          <img
            src={paymentSuccess}
            className="form_success_div_img"
            alt="payment-success"
          />
          <CheckCircleIcon className="form_success_div_Check" />
          <CircleIcon className="form_success_div_circle_right" />
          <CircleIcon className="form_success_div_circle_left" />
          <h1 className="form_success_div_h1">
            <h3>{text1}</h3>
            <h6>{text2}</h6>
          </h1>
        </div>

        <div className="form_success_pages_box_btn">
          <div className="form_success_pages_box_btn_area">
            <Link to={"/"} className="form_success_pages_box_go_btn">
              חזרה לדף הבית
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};
export default FormSuccess;
